import { CSSZSickLeaveValues } from '../Components/CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreate';
import {
	CSSZAddress,
	CSSZEmployment,
	CSSZSickLeaveCertificateFormValues,
	CSSZSickLeaveCreateAddress,
	CSSZSickLeaveCreateData,
	CSSZSickLeaveCreateEmployment,
	CSSZSickLeaveCreateSickLeave,
} from '../Interfaces/CSSZ.interface';
import moment from 'moment';

const prepareAddressForApi = (
	address: CSSZAddress,
): CSSZSickLeaveCreateAddress => {
	return {
		...address,
		typeOfAddress: address.typeOfAddress?.value as string,
		state: address.state.value as string,
	};
};

const prepareEmploymentForApi = (
	employment: CSSZEmployment,
): CSSZSickLeaveCreateEmployment => {
	return {
		...employment,
		address: prepareAddressForApi(employment.address),
		typeOfEmployment: employment.typeOfEmployment?.value as string | undefined,
	};
};

const prepareSickLeaveForApi = (
	sickLeave: CSSZSickLeaveCertificateFormValues & {
		submitToCssz?: boolean;
	},
): CSSZSickLeaveCreateSickLeave => {
	const {
		profession: _professionUiOnly,
		professionRequired: _professionRequiredUiOnly,
		submitToCssz: _submitToCssz,
		...rest
	} = sickLeave;
	return {
		...rest,
		insuranceAdministrator: sickLeave.insuranceAdministrator.value as string,
		diagnosis: sickLeave.diagnosis.value as string,
		createdAt: moment().format(),
	};
};

export const prepareDataForApi = (
	values: CSSZSickLeaveValues,
): CSSZSickLeaveCreateData => {
	return {
		patientAddress: prepareAddressForApi(values.patientAddress),
		employment: prepareEmploymentForApi(values.employment),
		sickLeave: prepareSickLeaveForApi(values.sickLeave),
		discourseDocumentId: values.discourseDocumentId,
	};
};
